import React from "react";

export const Copyright = () => {
  return (
    <footer className="bg-gray-900 text-center py-4 shadow-lg">
      <p className="text-white text-sm">
        © 2023 Portfolio of Masum . All rights reserved 
      </p>
    </footer>
  );
};

